module.exports = __webpack_public_path__ + "img/faceberry_cheek.9f8b99c5.png";